import React from 'react';
import classNames from 'classnames';

import Breadcrumbs from '../../../../shared/Breadcrumbs';

import { container } from './styles.module.css';

const CategoryBreadcrumbs = (props) => {
  const { className, combinedCategoryLinks, onClick } = props;
  return (
    <div className={classNames(container, className)}>
      {combinedCategoryLinks && (
        <Breadcrumbs
          useCategoryStyle
          links={combinedCategoryLinks}
          onClick={onClick}
        />
      )}
    </div>
  );
};

CategoryBreadcrumbs.propTypes = {};

CategoryBreadcrumbs.defaultProps = {};

export default CategoryBreadcrumbs;
